/* gatsby-quiz6.js — LP #19 wind-down protocol quiz engine.
   All content + scoring lives in the DOM (rendered by the gatsby-quiz6-* sections),
   so every screen, option, weight and copy string is Theme-Editor-editable.
   Effects grammar on data-fx: "scroller+2,heat+1,anchor=6.5,goal=sleep,tier=n28,gender=female"
   (scroller|overstim|restless|seeker|heat take +/- numbers; anchor|goal|tier|gender are assignments). */
(function () {
  'use strict';
  var root = document.getElementById('q6-root');
  if (!root) return;

  /* ---------- state ---------- */
  var S;
  function blank() {
    return { scores: { scroller: 0, overstim: 0, restless: 0, seeker: 0 }, heat: 0, anchor: null,
      gender: null, goal: null, picks: [], rankPts: {}, swaps: {}, tier: 'n28',
      answers: {}, history: [], idx: 0, email: '' };
  }

  /* ---------- adopt screens ----------
     Each screen renders inside its own Shopify section wrapper; move them all
     (in template order) into the frame's stage so the chrome wraps them. */
  var stage = root.querySelector('.q6-stage');
  [].slice.call(document.querySelectorAll('.q6-screen')).forEach(function (s) {
    /* remember which Shopify section this screen came from, so the Theme Editor can jump to it */
    var wrap = s.closest('[id^="shopify-section-"]');
    if (wrap) s.setAttribute('data-q6-section', wrap.id.replace('shopify-section-', ''));
    stage.appendChild(s);
  });

  /* ---------- DOM registry ---------- */
  var screens = [].slice.call(root.querySelectorAll('.q6-screen'));
  var counted = screens.filter(function (s) { return s.hasAttribute('data-counted'); });
  var QTOTAL = counted.length;
  var chrome = {
    back: root.querySelector('.q6-back'),
    count: root.querySelector('.q6-count'),
    prog: root.querySelector('.q6-progress i')
  };
  /* designs registry from rank cards (name -> meta) */
  var DESIGNS = {};
  [].slice.call(root.querySelectorAll('.q6-card[data-design]')).forEach(function (c) {
    DESIGNS[c.getAttribute('data-design')] = {
      name: c.getAttribute('data-design'), col: c.getAttribute('data-col'),
      effort: parseFloat(c.getAttribute('data-effort') || '3'),
      img: c.getAttribute('data-img') || '', note: c.getAttribute('data-note') || '',
      variant: c.getAttribute('data-variant') || ''
    };
  });
  /* pattern config from the profile section */
  var PATTERNS = {};
  [].slice.call(root.querySelectorAll('.q6-pat')).forEach(function (p) {
    PATTERNS[p.getAttribute('data-key')] = {
      name: p.getAttribute('data-name'), settledName: p.getAttribute('data-settled-name'),
      desc: p.getAttribute('data-desc'), settledDesc: p.getAttribute('data-settled-desc'),
      capHot: p.getAttribute('data-cap-hot'), protocol: p.getAttribute('data-protocol'),
      slot: p.getAttribute('data-slot'), advice: p.getAttribute('data-advice') || ''
    };
  });
  /* goal copy from the reveal section */
  var GOALS = {};
  [].slice.call(root.querySelectorAll('.q6-goal')).forEach(function (g) {
    GOALS[g.getAttribute('data-key')] = { label: g.getAttribute('data-label'), why: g.getAttribute('data-why') };
  });
  /* tiers from the reveal section (TIER_ORDER preserves block order for the plan selector) */
  var TIERS = {}, TIER_ORDER = [];
  [].slice.call(root.querySelectorAll('.q6-tier')).forEach(function (t) {
    var k = t.getAttribute('data-key');
    TIERS[k] = {
      key: k, label: t.getAttribute('data-label'),
      contents: t.getAttribute('data-contents'),
      count: parseInt(t.getAttribute('data-count') || '1', 10),
      blanks: parseInt(t.getAttribute('data-blanks') || '0', 10),
      days: parseInt(t.getAttribute('data-days') || '28', 10),
      discount: parseFloat(t.getAttribute('data-discount') || '0.65'),
      price: parseFloat(t.getAttribute('data-price') || '0'),
      compareAt: parseFloat(t.getAttribute('data-compare-at') || '0'),
      bestValue: t.getAttribute('data-best-value') === '1',
      withToolkit: t.getAttribute('data-with-toolkit') === '1'
    };
    TIER_ORDER.push(k);
  });

  /* one place for all bundle math. Explicit price/compareAt win; otherwise derive from the
     single-canvas anchor × count × discount multiplier (back-compat). */
  function priceOf(tier, single) {
    var count = tier.count || 1;
    var struck = tier.compareAt > 0 ? tier.compareAt : single * count;
    var offer = tier.price > 0 ? tier.price : struck * (tier.discount || 0.65);
    return {
      struck: struck, offer: offer,
      pct: struck > 0 ? Math.round((1 - offer / struck) * 100) : 0,
      perCanvas: count > 0 ? offer / count : 0,
      perDay: tier.days ? offer / tier.days : 0
    };
  }

  /* ---------- scoring ---------- */
  function applyFx(str) {
    if (!str) return;
    str.split(',').forEach(function (tok) {
      tok = tok.trim(); if (!tok) return;
      var kv = tok.split('=');
      if (kv.length === 2) {
        var k = kv[0].trim(), v = kv[1].trim();
        if (k === 'anchor') S.anchor = parseFloat(v);
        else if (k === 'goal') S.goal = v;
        else if (k === 'tier') S.tier = v;
        else if (k === 'gender') S.gender = v;
        return;
      }
      var m = tok.match(/^(scroller|overstim|restless|seeker|heat)([+\-][\d.]+)$/);
      if (!m) return;
      var amt = parseFloat(m[2]);
      if (m[1] === 'heat') S.heat += amt; else S.scores[m[1]] += amt;
    });
  }
  function topPattern() {
    var order = ['scroller', 'overstim', 'restless', 'seeker'], best = order[0];
    order.forEach(function (k) { if (S.scores[k] > S.scores[best]) best = k; });
    return S.scores[best] === 0 ? 'overstim' : best;
  }
  function meterVal() {
    var base = S.anchor == null ? 5 : S.anchor;
    var nudge = Math.max(-2, Math.min(3, S.heat));
    return Math.max(1, Math.min(10, Math.round(base + nudge)));
  }
  function patternView() {
    var p = PATTERNS[topPattern()] || {};
    return meterVal() <= 4 ? { name: p.settledName, desc: p.settledDesc, p: p } : { name: p.name, desc: p.desc, p: p };
  }

  /* ---------- navigation ---------- */
  function show(i) {
    screens.forEach(function (s, j) { s.classList.toggle('q6-on', j === i); });
    S.idx = i;
    var sc = screens[i];
    var qIdx = 0;
    for (var j = 0; j <= i; j++) if (screens[j].hasAttribute('data-counted')) qIdx++;
    if (chrome.count) chrome.count.textContent = sc.hasAttribute('data-counted') ? qIdx + ' / ' + QTOTAL : '';
    if (chrome.prog) chrome.prog.style.width = Math.round(100 * qIdx / QTOTAL) + '%';
    if (chrome.back) chrome.back.disabled = (i === 0) || sc.hasAttribute('data-noback');
    mount(sc);
    if (sc.getAttribute('data-kind') !== 'reveal') { var _sb = document.getElementById('q6-sticky'); if (_sb) _sb.classList.remove('is-on'); }
    root.scrollIntoView({ block: 'start', behavior: 'instant' in window ? 'instant' : 'auto' });
    window.scrollTo(0, root.offsetTop - 8);
    saveState();
  }
  function next() { if (S.idx < screens.length - 1) { S.history.push(S.idx); show(S.idx + 1); } }
  function back() { if (S.history.length) show(S.history.pop()); }
  if (chrome.back) chrome.back.addEventListener('click', back);

  /* ---------- per-kind mounting ---------- */
  function mount(sc) {
    var kind = sc.getAttribute('data-kind');
    if (kind === 'slider') mountSlider(sc);
    if (kind === 'tried') mountTried(sc);
    if (kind === 'rank') mountRank(sc);
    if (kind === 'profile') mountProfile(sc);
    if (kind === 'gauge') mountGauge(sc);
    if (kind === 'proof') mountProof(sc);
    if (kind === 'info') mountInfo(sc);
    if (kind === 'email') mountEmail(sc);
    if (kind === 'loading') mountLoading(sc);
    if (kind === 'reveal') mountReveal(sc);
    if (kind === 'cart') mountCart(sc);
    /* autoplay opted-in videos when the screen opens (muted): the section-level interlude video,
       plus any per-block video (a [data-autoplay] media block from the extras snippet) */
    var autoVids = [];
    if (sc.getAttribute('data-autoplay') === '1' && sc.querySelector('video')) autoVids.push(sc.querySelector('video'));
    [].slice.call(sc.querySelectorAll('[data-autoplay="1"] video')).forEach(function (v) { autoVids.push(v); });
    autoVids.forEach(function (v) { try { v.muted = true; v.play().catch(function () {}); } catch (e) {} });
  }

  /* shared cart permalink builder — chosen canvas variants (+ tool kit), optional reader
     discount code. `rev` is the reveal section (holds the tool-kit + discount-code settings). */
  function cartPath(weeks, tier, rev) {
    var variants = weeks.map(function (d) { return d.variant; }).filter(Boolean);
    var toolkit = rev && rev.getAttribute('data-toolkit-variant');
    if (tier.withToolkit && toolkit) variants.push(toolkit);
    if (!variants.length) return '';
    var path = '/cart/' + variants.map(function (vid) { return vid + ':1'; }).join(',');
    var code = (((tier && tier.bestValue && rev && rev.getAttribute('data-discount-code-bonus')) || (rev && rev.getAttribute('data-discount-code')) || '')).trim();
    if (code) path += '?discount=' + encodeURIComponent(code);
    return path;
  }

  /* ---------- Facebook/Meta pixel (fires only if the base code is present — fb_pixel_id set in
     the chrome section). AddToCart on "Start night one", InitiateCheckout on "Checkout securely",
     each synchronously on the click, with the offer value + chosen variants. */
  function fbVariants(weeks, tier, rev) {
    var v = weeks.map(function (d) { return d.variant; }).filter(Boolean);
    var toolkit = rev && rev.getAttribute('data-toolkit-variant');
    if (tier.withToolkit && toolkit) v.push(toolkit);
    return v;
  }
  function fbTrack(evt, weeks, tier, single, rev) {
    if (typeof window.fbq !== 'function') return;
    var ids = fbVariants(weeks, tier, rev);
    var value = Math.round(priceOf(tier, single).offer * 100) / 100;
    var currency = root.getAttribute('data-currency') || 'USD';
    try {
      window.fbq('track', evt, {
        content_type: 'product',
        content_ids: ids,
        contents: ids.map(function (id) { return { id: id, quantity: 1 }; }),
        num_items: ids.length,
        value: value,
        currency: currency
      });
    } catch (e) {}
  }

  /* tap questions + welcome gender buttons */
  [].slice.call(root.querySelectorAll('.q6-screen [data-fx]')).forEach(function (btn) {
    if (!btn.classList.contains('q6-opt') && !btn.classList.contains('q6-cta') && !btn.classList.contains('q6-ghost')) return;
    var sc = btn.closest('.q6-screen');
    var kind = sc.getAttribute('data-kind');
    if (kind !== 'tap' && kind !== 'welcome') return;
    btn.addEventListener('click', function () {
      var id = sc.getAttribute('data-id');
      if (id) S.answers[id] = btn.getAttribute('data-label') || btn.textContent.trim();
      applyFx(btn.getAttribute('data-fx'));
      next();
    });
  });

  /* sliders (relax + likert mirrors) */
  /* paint the orange fill to the left of the thumb (webkit needs JS; firefox uses ::-moz-range-progress) */
  function paintSlider(sl) {
    if (!sl) return;
    var max = parseFloat(sl.max) || 1;
    sl.style.setProperty('--q6-fill', (parseFloat(sl.value) / max * 100) + '%');
  }
  root.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('q6-sl')) paintSlider(t);
  });

  function sliderStops(sc) { return (sc.getAttribute('data-stops') || '').split('|'); }
  function mountSlider(sc) {
    var sl = sc.querySelector('.q6-sl'), now = sc.querySelector('.q6-now');
    var stops = sliderStops(sc);
    var upd = function () { if (now) now.textContent = '“' + (stops[+sl.value] || '') + '”'; };
    sl.oninput = upd; upd(); paintSlider(sl);
    var go = sc.querySelector('.q6-go');
    go.onclick = function () {
      var fx = (sc.getAttribute('data-fx-stops') || '').split('|')[+sl.value];
      applyFx(fx);
      var id = sc.getAttribute('data-id');
      if (id) S.answers[id] = stops[+sl.value];
      next();
    };
  }

  /* tried multi + efficacy follow-up */
  function mountTried(sc) {
    var sel = {}; var follow = sc.querySelector('.q6-follow');
    var sl = sc.querySelector('.q6-sl'), now = sc.querySelector('.q6-now');
    var stops = sliderStops(sc);
    var upd = function () { if (now) now.textContent = '“' + (stops[+sl.value] || '') + '”'; };
    sl.oninput = upd; paintSlider(sl);
    [].slice.call(sc.querySelectorAll('.q6-opt')).forEach(function (o) {
      o.classList.remove('q6-sel');
      o.onclick = function () {
        var k = o.getAttribute('data-key');
        sel[k] = !sel[k];
        o.classList.toggle('q6-sel', sel[k]);
        var any = Object.keys(sel).some(function (x) { return sel[x]; });
        follow.style.display = any ? 'block' : 'none';
        if (any) upd();
      };
    });
    follow.style.display = 'none';
    sc.querySelector('.q6-go').onclick = function () {
      var names = [];
      [].slice.call(sc.querySelectorAll('.q6-opt')).forEach(function (o) {
        var k = o.getAttribute('data-key');
        if (sel[k]) { applyFx(o.getAttribute('data-fx')); names.push(o.getAttribute('data-label') || ''); }
      });
      applyFx((sc.getAttribute('data-fx-stops') || '').split('|')[+sl.value]);
      S.answers.tried = names.filter(Boolean);
      S.answers.copeWorks = stops[+sl.value];
      next();
    };
  }

  /* ranking rounds */
  function mountRank(sc) {
    var order = [];
    var cards = [].slice.call(sc.querySelectorAll('.q6-card'));
    var go = sc.querySelector('.q6-go');
    function paint() {
      cards.forEach(function (c) {
        var n = c.getAttribute('data-design'), pos = order.indexOf(n);
        c.classList.toggle('q6-sel', pos >= 0);
        var b = c.querySelector('.q6-rk');
        if (pos >= 0) {
          if (!b) { b = document.createElement('span'); b.className = 'q6-rk'; c.prepend(b); }
          b.textContent = pos + 1;
        } else if (b) b.remove();
      });
      go.disabled = order.length !== cards.length;
    }
    cards.forEach(function (c) {
      c.onclick = function () {
        var n = c.getAttribute('data-design'), i = order.indexOf(n);
        if (i >= 0) order.splice(i, 1); else order.push(n);
        paint();
      };
    });
    paint();
    go.onclick = function () {
      order.forEach(function (n, i) { S.rankPts[n] = (S.rankPts[n] || 0) + (cards.length - i); });
      S.picks.push(order[0]);
      next();
    };
  }

  /* profile reveal */
  function fill(sc, key, val) {
    var el = sc.querySelector('[data-fill="' + key + '"]');
    if (el) el.innerHTML = val;
  }
  function bandCap(sc, m, p) {
    if (m <= 4) return sc.getAttribute('data-band-low') || '';
    if (m <= 7) return sc.getAttribute('data-band-mid') || '';
    return p.capHot || '';
  }
  function meterHtml(m) {
    var h = '';
    for (var i = 0; i < 10; i++) h += '<i class="' + (i < m ? 'q6-on' : '') + '"></i>';
    return h;
  }
  function mountProfile(sc) {
    var v = patternView(), m = meterVal();
    fill(sc, 'name', v.name); fill(sc, 'desc', v.desc);
    var bar = sc.querySelector('.q6-bar'); if (bar) bar.innerHTML = meterHtml(m);
    fill(sc, 'score', m + '/10');
    fill(sc, 'capline', bandCap(sc, m, v.p));
    /* genuinely useful, pattern-specific advice — the product is just the last beat of it */
    var g = S.goal && GOALS[S.goal];
    fill(sc, 'needline', (g ? 'You came for <b>' + g.label + '</b>. ' : '') + 'Here’s what actually moves the needle for evenings like yours:');
    var tips = (v.p.advice || '').split('|').filter(function (t) { return t.trim(); });
    fill(sc, 'advice', tips.map(function (t) {
      return '<div class="q6-adv"><span class="q6-adv-t">✓</span><span>' + t.trim() + '</span></div>';
    }).join(''));
  }

  /* severity gauge (stress-severity profile screen). Maps the 1–10 meter to a 4-band word
     (Low/Normal/Medium/High), fills the badge, and slides the "Your level" pin to that band.
     Optional: a [data-fill] tile (e.g. main difficulty) can be driven from the chosen goal. */
  function mountGauge(sc) {
    var m = meterVal();
    var bands = (sc.getAttribute('data-bands') || 'Low|Normal|Medium|High').split('|');
    var idx = m <= 3 ? 0 : (m <= 5 ? 1 : (m <= 7 ? 2 : 3));
    fill(sc, 'level', bands[idx]);
    var pin = sc.querySelector('.q6-yourlevel');
    if (pin) pin.style.left = (idx * 25 + 12.5) + '%';
    /* swap the preloaded profile image to the one matching this band (gender-aware if provided) */
    var bandKey = ['low', 'normal', 'medium', 'high'][idx];
    var imgs = [].slice.call(sc.querySelectorAll('.q6-pimg'));
    if (imgs.length) {
      var byBand = imgs.filter(function (i) { return i.getAttribute('data-band') === bandKey; });
      var chosen = byBand.filter(function (i) { return i.getAttribute('data-gender') === S.gender; })[0]
                || byBand.filter(function (i) { var gd = i.getAttribute('data-gender'); return !gd || gd === 'any'; })[0]
                || byBand[0] || null;
      imgs.forEach(function (i) { i.classList.toggle('q6-on', i === chosen); });
      var ph = sc.querySelector('.q6-baph'); if (ph) ph.style.display = chosen ? 'none' : '';
    }
    var g = S.goal && GOALS[S.goal];
    if (g) fill(sc, 'goal-tile', g.label);
  }

  /* matched proof — personalized eyebrow + a swipeable image carousel that sizes to each slide */
  function mountProof(sc) {
    var v = patternView();
    var eb = sc.querySelector('[data-fill="proof-eyebrow"]');
    if (eb) eb.textContent = (eb.getAttribute('data-tpl') || '[P]').replace('[P]', (v.name || '').replace(/^The /, ''));

    var car = sc.querySelector('[data-q6-carousel]');
    if (!car) return;
    if (car._q3) { car._q3.refresh(); return; } /* already built — just re-fit on re-show */

    var track = car.querySelector('.q6-car-track');
    var slides = [].slice.call(car.querySelectorAll('.q6-car-slide'));
    if (!slides.length) return;
    var prev = car.querySelector('.q6-car-prev'), next = car.querySelector('.q6-car-next');
    var dotsWrap = sc.querySelector('.q6-car-dots');
    var idx = 0;

    if (dotsWrap && slides.length > 1) {
      slides.forEach(function (_, i) {
        var d = document.createElement('button');
        d.className = 'q6-car-dot'; d.type = 'button'; d.setAttribute('aria-label', 'Slide ' + (i + 1));
        d.onclick = function () { go(i); };
        dotsWrap.appendChild(d);
      });
    }
    var dots = dotsWrap ? [].slice.call(dotsWrap.children) : [];

    function fit() { var h = slides[idx].offsetHeight; if (h) car.style.height = h + 'px'; }
    function render() {
      track.style.transform = 'translateX(' + (-idx * 100) + '%)';
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === idx); });
      if (prev) prev.disabled = idx === 0;
      if (next) next.disabled = idx === slides.length - 1;
      fit();
    }
    function go(i) { idx = Math.max(0, Math.min(slides.length - 1, i)); render(); }

    if (prev) prev.onclick = function () { go(idx - 1); };
    if (next) next.onclick = function () { go(idx + 1); };
    slides.forEach(function (s) {
      var img = s.querySelector('img');
      if (img && !img.complete) img.addEventListener('load', function () { if (slides[idx] === s) fit(); });
    });
    var x0 = null;
    car.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    car.addEventListener('touchend', function (e) {
      if (x0 == null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });

    car._q3 = { go: go, refresh: render };
    render();
    setTimeout(fit, 60); /* after layout/fonts settle */
  }

  /* info screens: [PROTOCOL] token */
  function mountInfo(sc) {
    [].slice.call(sc.querySelectorAll('[data-token]')).forEach(function (el) {
      var tpl = el.getAttribute('data-token');
      el.innerHTML = tpl.replace('[PROTOCOL]', (PATTERNS[topPattern()] || {}).protocol || 'your protocol');
    });
  }

  /* email gate */
  function mountEmail(sc) {
    var input = sc.querySelector('.q6-email-input'), go = sc.querySelector('.q6-go');
    var consent = sc.querySelector('.q6-consent-box');
    var required = sc.getAttribute('data-consent-required') === '1';
    var consentTag = (sc.getAttribute('data-consent-tag') || '').trim();
    function ok() {
      return /.+@.+\..+/.test(input.value) && (!consent || !required || consent.checked);
    }
    var upd = function () { go.disabled = !ok(); };
    input.oninput = upd; if (consent) consent.addEventListener('change', upd); upd();
    go.onclick = function () {
      if (go.disabled) return;
      S.email = input.value.trim();
      var consented = !!(consent && consent.checked);
      var tags = 'gatsby-quiz6-wind-down' + (consented && consentTag ? ',' + consentTag : '');
      try {
        var fd = new FormData();
        fd.append('form_type', 'customer'); fd.append('utf8', '✓');
        fd.append('contact[email]', S.email);
        fd.append('contact[tags]', tags);
        if (consented) fd.append('contact[accepts_marketing]', 'true');
        fetch('/contact#contact_form', { method: 'POST', body: fd }).catch(function () {});
      } catch (e) {}
      next();
    };
  }

  /* loading — a stacked "calculating" checklist, personalized with the user's pattern + score */
  function mountLoading(sc) {
    var tok = function (s) {
      return s.replace('[PATTERN]', patternView().name || 'your pattern')
              .replace('[SCORE]', meterVal() + '/10');
    };
    var lines = (sc.getAttribute('data-lines') || 'One moment').split('|').map(tok);
    var stepMs = parseInt(sc.getAttribute('data-step-ms') || '1140', 10);
    // uneven cadence so it reads like real work, not a fixed timer:
    // quick to start, lingers on the "calculating / tailoring" steps
    var factor = [0.75, 0.95, 1.35, 1.15, 1.3, 1.15, 0.95, 0.8];
    var titleEl = sc.querySelector('.q6-load-title');
    var doneEl = sc.querySelector('.q6-load-done');
    var lineEl = sc.querySelector('.q6-load-line');
    if (titleEl) titleEl.textContent = sc.getAttribute('data-title') || '';
    doneEl.innerHTML = '';
    var i = 0;
    lineEl.textContent = lines[0] + '…';
    function step() {
      var d = document.createElement('div');
      d.className = 'q6-load-item';
      d.innerHTML = '<span class="q6-load-tick">✓</span><span>' + lines[i] + '</span>';
      doneEl.appendChild(d);
      i++;
      if (i >= lines.length) {
        lineEl.textContent = '';
        sc.querySelector('.q6-load-active').style.display = 'none';
        /* in the Theme Editor, stay put so it can be inspected; live, advance to the reveal */
        if (!(window.Shopify && Shopify.designMode)) setTimeout(next, Math.round(stepMs * 0.9));
        return;
      }
      lineEl.textContent = lines[i] + '…';
      setTimeout(step, Math.round(stepMs * (factor[i] || 1)));
    }
    setTimeout(step, Math.round(stepMs * (factor[0] || 1)));
  }

  /* ---------- final reveal ---------- */
  var FREESTYLE = '__freestyle__';
  /* the freestyle/blank-canvas pseudo-design — never in the default plan, only via swap */
  function freestyleDesign() {
    var r = root.querySelector('.q6-screen[data-kind="reveal"]');
    return { name: (r && r.getAttribute('data-week4-title')) || 'Blank Canvas', col: 'freestyle',
      effort: 99, img: '', note: (r && r.getAttribute('data-week4-desc')) || '', variant: '', freestyle: true };
  }
  /* produce `count` COLORED canvases: round winners first, then next-best by rank points, effort-ordered */
  function buildWeeks(count) {
    var winners = S.picks.map(function (n) { return DESIGNS[n]; }).filter(Boolean);
    var seen = {}; winners.forEach(function (w) { seen[w.name] = 1; });
    var ranked = Object.keys(S.rankPts).map(function (n) { return DESIGNS[n]; }).filter(Boolean)
      .filter(function (d) { return !seen[d.name]; })
      .sort(function (a, b) { return (S.rankPts[b.name] - S.rankPts[a.name]) || (a.effort - b.effort); });
    var chosen = winners.concat(ranked).slice(0, count).sort(function (a, b) { return a.effort - b.effort; });
    return chosen.map(function (d, i) {
      if (S.swaps[i] === FREESTYLE) return freestyleDesign();
      return S.swaps[i] ? (DESIGNS[S.swaps[i]] || d) : d;
    });
  }
  /* swap options: colored ranked alternatives + a Freestyle option (only when the week isn't already freestyle) */
  function altsFor(i, weeks) {
    var used = weeks.map(function (d) { return d.name; });
    var cur = weeks[i], target = cur.effort;
    var colored = Object.keys(S.rankPts).map(function (n) { return DESIGNS[n]; }).filter(Boolean)
      .filter(function (d) { return used.indexOf(d.name) < 0; })
      .sort(function (a, b) {
        return (S.rankPts[b.name] - S.rankPts[a.name]) || (Math.abs(a.effort - target) - Math.abs(b.effort - target));
      });
    /* Freestyle disabled on these bundles: every week stays a real canvas so the fixed
       per-tier discount never desyncs from the paid-canvas count. */
    return colored.slice(0, 3);
  }
  var altOpen = null;
  /* ---------- mystery-gift unlock (value stack; reveals on the best-value tier) ---------- */
  var giftLastVal = -1, giftWasBonus = false;
  function giftCountUp(el, from, to, ms) {
    if (from < 0 || Math.abs(from - to) < 0.005) { el.textContent = '$' + to.toFixed(2); return; }
    var t0 = null;
    function step(ts) {
      if (!t0) t0 = ts;
      var k = Math.min((ts - t0) / ms, 1);
      var val = from + (to - from) * (1 - Math.pow(1 - k, 3));
      el.textContent = '$' + val.toFixed(2);
      if (k < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function mountGift(slotHost, cfg, tier, single) {
    var slot = slotHost.querySelector('[data-fill="mysterygift"]');
    if (!slot) return;
    if (cfg.getAttribute('data-mg-enabled') !== '1') { slot.innerHTML = ''; return; }
    var A = function (k, d) { var x = cfg.getAttribute(k); return (x === null || x === '') ? d : x; };
    var baseM = parseInt(A('data-mg-base-mystery', '1'), 10) || 0;
    var bonusM = parseInt(A('data-mg-bonus-mystery', '3'), 10) || 0;
    var bonusStylus = A('data-mg-bonus-stylus', '0') === '1';
    var stylusVal = parseFloat(A('data-mg-stylus-value', '24')) || 0;
    var mysteryVal = parseFloat(A('data-mg-mystery-value','0')) || (single > 0 ? single : 27.99);
    var isBonus = !!tier.bestValue;
    var curM = isBonus ? bonusM : baseM;
    var curStylus = isBonus ? bonusStylus : false;
    var totalRows = Math.max(bonusM, baseM);
    var value = curM * mysteryVal + (curStylus ? stylusVal : 0);
    var dispVal = Math.round(value) - 0.01;
    var mName = A('data-mg-mystery-name', 'Mystery canvas');
    var mSub = A('data-mg-mystery-sub', 'A surprise design, hand-picked for you');
    var unlockSub = A('data-mg-unlocked-sub', 'Yours free — added to your set');
    var lockSub = A('data-mg-locked-sub', 'Unlocks with the best-value plan');
    var rows = '';
    for (var i = 0; i < totalRows; i++) {
      var locked = i >= curM;
      var sub = locked ? lockSub : (i === 0 ? mSub : unlockSub);
      rows += '<div class="q6-mg-row' + (locked ? ' is-locked' : '') + '">'
        + '<div class="q6-mg-ic">?</div>'
        + '<div class="q6-mg-t"><b>' + mName + ' #' + (i + 1) + '</b><small>' + sub + '</small></div>'
        + '<div class="q6-mg-v">' + (locked ? '$' + mysteryVal.toFixed(2) : 'FREE') + '</div></div>';
    }
    if (bonusStylus) {
      var sLocked = !curStylus;
      rows += '<div class="q6-mg-row' + (sLocked ? ' is-locked' : '') + '">'
        + '<div class="q6-mg-ic q6-mg-ic-crys">◆</div>'
        + '<div class="q6-mg-t"><b>' + A('data-mg-stylus-name', 'Crystal stylus') + '</b><small>' + (sLocked ? lockSub : unlockSub) + '</small></div>'
        + '<div class="q6-mg-v">' + (sLocked ? '$' + stylusVal.toFixed(2) : 'FREE') + '</div></div>';
    }
    var justUnlocked = isBonus && !giftWasBonus;
    var cardCls = 'q6-mg-card' + (isBonus ? ' is-on' : '') + (justUnlocked ? ' is-unlock' : '');
    var hint = A('data-mg-hint', '');
    slot.innerHTML =
      '<div class="q6-mg-eyebrow">' + A('data-mg-section-label', 'Free gifts included') + '</div>'
      + '<div class="' + cardCls + '">'
      + '<div class="q6-mg-head"><span class="q6-mg-label">' + A('data-mg-value-label', 'Free gift value')
      + (isBonus ? '<span class="q6-mg-tag">' + A('data-mg-free-tag', 'All free') + '</span>' : '') + '</span>'
      + '<span class="q6-mg-amt">$' + dispVal.toFixed(2) + '</span></div>'
      + '<div class="q6-mg-rows">' + rows + '</div>'
      + ((!isBonus && hint) ? '<div class="q6-mg-hint">' + hint + '</div>' : '')
      + '</div>';
    var amtEl = slot.querySelector('.q6-mg-amt');
    if (amtEl) giftCountUp(amtEl, giftLastVal, dispVal, 850);
    giftLastVal = dispVal;
    giftWasBonus = isBonus;
  }
  function mountReveal(sc) {
    var v = patternView(), p = v.p, m = meterVal();
    if (!TIERS[S.tier]) S.tier = TIER_ORDER[0] || 'n28';
    var tier = TIERS[S.tier];
    var single = parseFloat(sc.getAttribute('data-single-price') || '0');
    var disc = tier.discount || 0.65;

    /* one-line recap — the diagnosis details already lived on the pattern screen */
    var g = S.goal && GOALS[S.goal];
    fill(sc, 'recap', '<b>' + v.name + '</b> · ' + m + '/10 stress' + (g ? ' · for ' + g.label : '') + '.');
    fill(sc, 'protocol', p.protocol || '');
    var slotLead = 'Your slot: <b>' + (p.slot || '') + '</b>. ';
    slotLead += m >= 5 ? (sc.getAttribute('data-plan-hot') || '') : (sc.getAttribute('data-plan-low') || '');
    slotLead += ' ' + (sc.getAttribute('data-plan-built') || '');
    fill(sc, 'slotline', slotLead);

    /* plan selector — compare 4-week vs 8-week by per-day cost; tap to switch */
    var badge = sc.getAttribute('data-best-value-badge') || 'Best value';
    var planEl = sc.querySelector('[data-fill="planselect"]');
    if (planEl) {
      planEl.innerHTML = TIER_ORDER.map(function (k) {
        var tt = TIERS[k]; if (!tt) return '';
        var pp = priceOf(tt, single);
        var tot = pp.offer;
        var perDay = pp.perDay;
        return '<button class="q6-plan' + (k === S.tier ? ' is-on' : '') + '" data-tier="' + k + '" role="radio" aria-checked="' + (k === S.tier) + '" aria-label="' + tt.label + ', $' + (tt.days ? perDay.toFixed(2) : '0') + ' per day, $' + tot.toFixed(2) + ' total">'
          + (tt.bestValue ? '<span class="q6-plan-badge">' + badge + '</span>' : '')
          + '<span class="q6-plan-name">' + tt.label + '</span>'
          + '<span class="q6-plan-day">$' + perDay.toFixed(2) + '<small>/day</small></span>'
          + '<span class="q6-plan-tot">$' + tot.toFixed(2) + ' total</span></button>';
      }).join('');
      [].slice.call(planEl.querySelectorAll('.q6-plan')).forEach(function (b) {
        b.onclick = function () {
          var k = b.getAttribute('data-tier');
          if (k !== S.tier) { S.tier = k; S.swaps = {}; altOpen = null; mountReveal(sc); }
        };
      });
    }

    mountGift(sc, sc, tier, single);

    var cnt = tier.count || 1, blanks = tier.blanks || 0;
    var weeks = buildWeeks(cnt);
    var labels = (sc.getAttribute('data-week-labels') || 'An easy arrival|A steadier build|The deep one').split('|');
    var colNames = { calming: 'Calming Nature', cities: 'Midnight Cities', japan: 'Tales of Japan' };
    var lbl = function (i) { return i === 0 ? labels[0] : (i === weeks.length - 1 ? labels[2] : labels[1]); };
    var priceTag = single > 0 ? '<s class="q6-nm-price">$' + single.toFixed(2) + '</s>' : '';
    var html = weeks.map(function (d, i) {
      var alts = altsFor(i, weeks);
      var pickTag = (!d.freestyle && S.rankPts[d.name]) ? ' · ★ your pick' : '';
      var thumb = d.freestyle ? '<div class="q6-thumb">∅</div>' : '<div class="q6-thumb q6-zoomable" data-full="' + d.img + '" data-full-alt="' + d.name + '" data-full-series="' + (colNames[d.col] || '') + '" style="background-image:url(\'' + d.img + '\')"></div>';
      var line2 = d.freestyle ? 'Freestyle' : (colNames[d.col] || '');
      var nm = d.freestyle ? d.name : d.name + ' ' + priceTag;
      var out = '<div class="q6-week">' + thumb
        + '<div><div class="q6-wk">Week ' + (i + 1) + ' · ' + lbl(i) + ' · ' + line2 + pickTag + '</div>'
        + '<div class="q6-nm">' + nm + '</div><div class="q6-why">' + d.note + '</div>'
        + (alts.length ? '<button class="q6-swap" data-swap="' + i + '">' + (altOpen === i ? '✕ keep this one' : '⇄ swap this week') + '</button>' : '')
        + '</div></div>';
      if (altOpen === i) {
        out += '<div class="q6-alts">' + alts.map(function (a) {
          var aId = a.freestyle ? FREESTYLE : a.name.replace(/"/g, '');
          var aThumb = a.freestyle ? '<span class="q6-thumb">∅</span>' : '<span class="q6-thumb" style="background-image:url(\'' + a.img + '\')"></span>';
          var aName = a.freestyle ? 'Freestyle' : a.name;
          var aSub = a.freestyle ? 'blank · your own design' : (colNames[a.col] || '') + ' · same calm zone';
          return '<button class="q6-alt" data-swapto="' + i + ':' + aId + '">' + aThumb + '<span>' + aName + '<small>' + aSub + '</small></span></button>';
        }).join('') + '</div>';
      }
      return out;
    }).join('');
    for (var bk = 0; bk < blanks; bk++) {
      html += '<div class="q6-week"><div class="q6-thumb">∅</div><div><div class="q6-wk">Week ' + (weeks.length + bk + 1) + ' · Freestyle</div><div class="q6-nm">' + (sc.getAttribute('data-week4-title') || 'Blank Canvas') + '</div><div class="q6-why">' + (sc.getAttribute('data-week4-desc') || '') + '</div></div></div>';
    }
    var weeksEl = sc.querySelector('[data-fill="weeks"]');
    if (weeksEl) {
      weeksEl.innerHTML = html;
      [].slice.call(weeksEl.querySelectorAll('[data-swap]')).forEach(function (b) {
        b.onclick = function () { var i = +b.getAttribute('data-swap'); altOpen = altOpen === i ? null : i; mountReveal(sc); };
      });
      [].slice.call(weeksEl.querySelectorAll('[data-swapto]')).forEach(function (b) {
        b.onclick = function () {
          var kv = b.getAttribute('data-swapto').split(':');
          S.swaps[+kv[0]] = kv[1]; altOpen = null; mountReveal(sc);
        };
      });
    }

    /* pricing: explicit tier price/compareAt if set, else derived from the single-canvas anchor */
    var pp = priceOf(tier, single);
    var struckTotal = pp.struck, offer = pp.offer, pct = pp.pct;
    fill(sc, 'price', '<span class="q6-price-old">$' + struckTotal.toFixed(2) + '</span><span class="q6-price-new">$' + offer.toFixed(2) + '</span><span class="q6-price-tag">' + pct + '% ' + (sc.getAttribute('data-price-tag') || 'READER DISCOUNT') + '</span>');
    fill(sc, 'tierline', tier.label + ' · ' + tier.contents);
    if (single > 0 && cnt > 0) {
      fill(sc, 'perpiece', 'Works out to <b>$' + pp.perCanvas.toFixed(2) + '</b> a canvas. Bought one at a time, each is <s>$' + single.toFixed(2) + '</s>.');
    } else { fill(sc, 'perpiece', ''); }

    /* CTA: if an in-funnel cart screen exists, advance to it (it builds the checkout link
       from the same chosen weeks); otherwise fall back to the direct /cart permalink. */
    var ctaA = sc.querySelector('a.q6-cta');
    if (ctaA) {
      var cartScreen = root.querySelector('.q6-screen[data-kind="cart"]');
      if (cartScreen) {
        ctaA.setAttribute('href', '#');
        ctaA.onclick = function (e) {
          e.preventDefault();
          fbTrack('AddToCart', weeks, tier, single, sc); /* fire AddToCart on the click */
          var i = screens.indexOf(cartScreen);
          if (i >= 0) { S.history.push(S.idx); show(i); }
        };
      } else {
        var path = cartPath(weeks, tier, sc);
        if (path) ctaA.setAttribute('href', path);
      }
    }
    setupRevealSticky(sc);
  }

  /* sticky "jump to the offer CTA" bar — appears on the reveal when the main CTA scrolls out of view,
     and smooth-scrolls the visitor back to it. Reveal screen only. */
  var q6StickyObs = null;
  function setupRevealSticky(sc) {
    var cta = sc.querySelector('a.q6-cta');
    if (!cta || !('IntersectionObserver' in window)) return;
    var bar = document.getElementById('q6-sticky');
    if (!bar) {
      bar = document.createElement('div'); bar.id = 'q6-sticky'; bar.className = 'q6-sticky';
      bar.innerHTML = '<button type="button" class="q6-sticky-btn"></button>';
      root.appendChild(bar);
      bar.querySelector('.q6-sticky-btn').addEventListener('click', function () {
        var c = root.querySelector('.q6-screen.q6-on a.q6-cta') || cta;
        c.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
    bar.querySelector('.q6-sticky-btn').textContent = (cta.textContent || 'Start').trim();
    if (q6StickyObs) q6StickyObs.disconnect();
    q6StickyObs = new IntersectionObserver(function (entries) {
      var e = entries[0];
      if (sc.classList.contains('q6-on') && !e.isIntersecting) bar.classList.add('is-on');
      else bar.classList.remove('is-on');
    }, { threshold: 0 });
    q6StickyObs.observe(cta);
  }

  /* ---------- in-funnel cart review ---------- */
  function mountCart(sc) {
    var rev = root.querySelector('.q6-screen[data-kind="reveal"]');
    if (!TIERS[S.tier]) S.tier = TIER_ORDER[0] || 'n28';
    var tier = TIERS[S.tier];
    var single = parseFloat((rev && rev.getAttribute('data-single-price')) || '0');
    var pp = priceOf(tier, single);
    var cnt = tier.count || 1;
    var weeks = buildWeeks(cnt);
    var colNames = { calming: 'Calming Nature', cities: 'Midnight Cities', japan: 'Tales of Japan' };
    var labels = ((rev && rev.getAttribute('data-week-labels')) || 'An easy arrival|A steadier build|The deep one').split('|');
    var lbl = function (i) { return i === 0 ? labels[0] : (i === weeks.length - 1 ? labels[2] : labels[1]); };
    var attr = function (a, def) { return sc.getAttribute(a) || def; };

    /* recap: the plan they picked, in plain words */
    fill(sc, 'cart-recap', tier.label + ' · ' + cnt + ' ' + (cnt === 1 ? 'canvas' : 'canvases') + (tier.withToolkit ? ' + tool set' : '') + '.');

    /* line items — the same chosen weeks the reveal shows, priced off the single anchor */
    var perCanvas = pp.perCanvas;
    var items = weeks.map(function (d, i) {
      var thumb = d.freestyle
        ? '<div class="q6-ci-thumb q6-ci-blank">∅</div>'
        : '<div class="q6-ci-thumb q6-zoomable" data-full="' + d.img + '" data-full-alt="' + d.name + '" data-full-series="' + (colNames[d.col] || '') + '" style="background-image:url(\'' + d.img + '\')"></div>';
      var sub = 'Week ' + (i + 1) + ' · ' + lbl(i) + ' · ' + (d.freestyle ? 'Freestyle' : (colNames[d.col] || ''));
      var price = d.freestyle
        ? '<span class="q6-ci-free">Your design</span>'
        : '<span class="q6-ci-now">$' + perCanvas.toFixed(2) + '</span><s class="q6-ci-was">$' + single.toFixed(2) + '</s>';
      return '<div class="q6-ci">' + thumb
        + '<div class="q6-ci-meta"><div class="q6-ci-nm">' + d.name + '</div><div class="q6-ci-sub">' + sub + '</div></div>'
        + '<div class="q6-ci-price">' + price + '</div></div>';
    }).join('');

    /* tool kit, presented as included (matches the offer; real charge reconciled at checkout) */
    var toolkit = rev && rev.getAttribute('data-toolkit-variant');
    if (tier.withToolkit && toolkit) {
      items += '<div class="q6-ci q6-ci-kit">'
        + '<div class="q6-ci-thumb q6-ci-kiticon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20h4L18.5 9.5a2.12 2.12 0 0 0-3-3L5 17v3z"/><path d="M13.5 6.5l3 3"/></svg></div>'
        + '<div class="q6-ci-meta"><div class="q6-ci-nm">' + attr('data-kit-name', '5-Piece Tool Set') + '</div><div class="q6-ci-sub">' + attr('data-kit-sub', '') + '</div></div>'
        + '<div class="q6-ci-price"><span class="q6-ci-inc">' + attr('data-included-label', 'Included') + '</span></div></div>';
    }
    fill(sc, 'items', items || attr('data-empty', ''));

    /* free-gift value stack — same as the reveal, config read from the reveal section */
    if (rev) mountGift(sc, rev, tier, single);

    /* summary — mirrors the reveal numbers exactly */
    var struckTotal = pp.struck;
    var offer = pp.offer;
    var saved = struckTotal - offer;
    var pct = pp.pct;
    var perDay = pp.perDay;
    var row = function (a, b) { return '<div class="q6-sum-row"><span>' + a + '</span><span>' + b + '</span></div>'; };
    var sum = '';
    sum += row(attr('data-subtotal-label', 'Canvases') + ' (' + cnt + ')', '<s>$' + struckTotal.toFixed(2) + '</s>');
    sum += row(attr('data-discount-label', 'Reader discount') + ' (' + pct + '%)', '<span class="q6-sum-save">−$' + saved.toFixed(2) + '</span>');
    if (tier.withToolkit && toolkit) sum += row(attr('data-kit-name', '5-Piece Tool Set'), '<span class="q6-ci-inc">' + attr('data-included-label', 'Included') + '</span>');
    sum += row(attr('data-shipping-label', 'Shipping'), attr('data-shipping-value', 'Free'));
    sum += '<div class="q6-sum-total"><span>' + attr('data-total-label', 'Total today') + '</span><span class="q6-sum-tot">$' + offer.toFixed(2) + '</span></div>';
    if (tier.days) {
      sum += '<div class="q6-sum-perday">' + attr('data-perday-tpl', "That's [PERDAY]/day across [DAYS] nights.")
        .replace('[PERDAY]', '$' + perDay.toFixed(2)).replace('[DAYS]', String(tier.days)) + '</div>';
    }
    fill(sc, 'summary', sum);

    /* checkout handoff — add via the AJAX Cart API so Shopify emits product_added_to_cart
       (→ AddToCart on any connected pixel), then go to checkout. The /cart permalink stays as the
       no-JS / middle-click fallback and the error fallback. */
    var ctaA = sc.querySelector('a.q6-cta');
    if (ctaA) {
      var variants = weeks.map(function (d) { return d.variant; }).filter(Boolean);
      var toolkit = rev && rev.getAttribute('data-toolkit-variant');
      if (tier.withToolkit && toolkit) variants.push(toolkit);
      var code = (((tier && tier.bestValue && rev && rev.getAttribute('data-discount-code-bonus')) || (rev && rev.getAttribute('data-discount-code')) || '')).trim();
      var dest = code ? ('/discount/' + encodeURIComponent(code) + '?redirect=/checkout') : '/checkout';
      var permalink = cartPath(weeks, tier, rev) || attr('data-cart-fallback', '/cart');
      ctaA.setAttribute('href', permalink);
      ctaA.onclick = function (e) {
        if (!variants.length || !window.fetch) return; /* no JS / no items: use the fallback href */
        e.preventDefault();
        if (ctaA.getAttribute('data-q6-busy')) return;
        ctaA.setAttribute('data-q6-busy', '1');
        fbTrack('InitiateCheckout', weeks, tier, single, rev); /* fire InitiateCheckout on the click */
        var items = variants.map(function (v) { return { id: v, quantity: 1 }; });
        var H = { 'Content-Type': 'application/json' };
        fetch('/cart/clear.js', { method: 'POST', headers: H })
          .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: H, body: JSON.stringify({ items: items }) }); })
          .then(function () { setTimeout(function () { window.location.href = dest; }, 120); }) /* let the AddToCart beacon flush */
          .catch(function () { window.location.href = permalink; }); /* server-side permalink add */
      };
    }
    var edit = sc.querySelector('[data-q6-edit]');
    if (edit) edit.onclick = function () { back(); };
  }

  /* retake */
  [].slice.call(root.querySelectorAll('[data-q6-retake]')).forEach(function (b) {
    b.addEventListener('click', function () { clearState(); S = blank(); altOpen = null; giftLastVal = -1; giftWasBonus = false; show(0); });
  });
  /* generic continue buttons on info/profile/proof screens */
  [].slice.call(root.querySelectorAll('[data-q6-next]')).forEach(function (b) {
    b.addEventListener('click', next);
  });

  /* ---------- tap-to-zoom design preview (lightbox) ---------- */
  function q6Zoom(src, name, series) {
    if (!src) return;
    var lb = document.getElementById('q6-zoom');
    if (!lb) {
      lb = document.createElement('div'); lb.id = 'q6-zoom'; lb.className = 'q6-zoom';
      lb.innerHTML = '<div class="q6-zoom-card"><button type="button" class="q6-zoom-x" aria-label="Close preview">✕</button>'
        + '<div class="q6-zoom-imgwrap"><img class="q6-zoom-img" alt=""></div>'
        + '<div class="q6-zoom-cap"><div class="q6-zoom-name"></div><div class="q6-zoom-series"></div></div></div>';
      document.body.appendChild(lb);
      lb.__close = function () { lb.classList.remove('is-on'); document.documentElement.style.overflow = ''; };
      /* tap anywhere outside the image (backdrop, card padding, caption, or the ✕) closes */
      lb.addEventListener('click', function (e) { if (!e.target.closest('.q6-zoom-imgwrap')) lb.__close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') lb.__close(); });
    }
    lb.querySelector('.q6-zoom-img').src = src;
    lb.querySelector('.q6-zoom-img').alt = name || '';
    var nm = lb.querySelector('.q6-zoom-name'); nm.textContent = name || ''; nm.style.display = name ? '' : 'none';
    var sr = lb.querySelector('.q6-zoom-series'); sr.textContent = series || ''; sr.style.display = series ? '' : 'none';
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { requestAnimationFrame(function () { lb.classList.add('is-on'); }); });
  }
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-full]');
    if (t) { e.preventDefault(); q6Zoom(t.getAttribute('data-full'), t.getAttribute('data-full-alt'), t.getAttribute('data-full-series')); }
  });

  /* ---------- hide the third-party currency-converter widget on the funnel ----------
     This store runs the Nova/Booster converter — the floating switcher is #baCurrSelector,
     injected late by booster_currency.js. Hide via CSS + a JS sweep + a short-lived observer. */
  function q6HideCurrency() {
    var sel = '#baCurrSelector,#nova-cur-app-embed-init,[id*="baCurr"],.bss-currency-switcher,[class*="bss-currency"],[class*="nova-multi-currency-converter"],.cc-currency,.currency-switcher,.currency-converter,.currency-picker';
    [].slice.call(document.querySelectorAll(sel)).forEach(function (el) { el.style.setProperty('display', 'none', 'important'); });
  }
  q6HideCurrency();
  /* CSS already hides the switcher at any depth/timing; this shallow body-level observer is only a
     cheap safety net for late inline-style injection (fires only on direct body-child changes, not
     on the engine's in-funnel DOM churn), and disconnects quickly. No perf cost on screen transitions. */
  if (window.MutationObserver && document.body) {
    var q6cmo = new MutationObserver(q6HideCurrency);
    q6cmo.observe(document.body, { childList: true });
    setTimeout(function () { q6cmo.disconnect(); }, 6000);
  }
  setTimeout(q6HideCurrency, 800); setTimeout(q6HideCurrency, 2500);

  /* ---------- state persistence: resume the same screen on refresh (per-page sessionStorage) ---------- */
  var Q6KEY = 'gatsby-quiz6:' + location.pathname;
  function saveState() { try { sessionStorage.setItem(Q6KEY, JSON.stringify(S)); } catch (e) {} }
  function loadState() { try { var raw = sessionStorage.getItem(Q6KEY); if (raw) { var o = JSON.parse(raw); if (o && typeof o.idx === 'number') return o; } } catch (e) {} return null; }
  function clearState() { try { sessionStorage.removeItem(Q6KEY); } catch (e) {} }

  /* ---------- boot ---------- */
  var q6saved = loadState();
  S = q6saved || blank();
  show(q6saved && q6saved.idx >= 0 && q6saved.idx < screens.length ? q6saved.idx : 0);

  /* ---------- Theme Editor: clicking a "Page N" section (or a block in it) jumps the preview
     to that screen. The funnel shows one screen at a time, so without this the preview just
     stays on whatever screen is active. Only runs in the editor (Shopify.designMode). */
  if (window.Shopify && Shopify.designMode) {
    /* section ids look like "template--123__goal"; match on the trailing key so it works whether
       the event sends the full id or just the key. */
    var keyOf = function (s) { s = s || ''; var i = s.lastIndexOf('__'); return i >= 0 ? s.slice(i + 2) : s; };
    var showScreen = function (el) { var i = screens.indexOf(el); if (i >= 0) show(i); };
    document.addEventListener('shopify:section:select', function (e) {
      var sid = keyOf(e.detail && e.detail.sectionId);
      for (var j = 0; j < screens.length; j++) {
        if (keyOf(screens[j].getAttribute('data-q6-section')) === sid) { show(j); return; }
      }
    });
    document.addEventListener('shopify:block:select', function (e) {
      showScreen(e.target && e.target.closest ? e.target.closest('.q6-screen') : null);
    });
  }
})();
